import TagSelect from './TagSelect';

export default TagSelect;



// WEBPACK FOOTER //
// ./src/tagSelect/index.js